import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { BoxProps } from "@mui/material/Box";

import * as S from "./style";

interface BasicModalProps {
	readonly title?: React.ReactNode;
	readonly subtitle?: React.ReactNode;
	readonly children?: React.ReactNode;
	readonly open: boolean;
	readonly handleClose: () => void;
	readonly disableOutsideClick?: boolean;
	readonly titleAlign?: "left" | "center" | "right";
	readonly boxStyle?: React.CSSProperties;
	readonly boxProps?: BoxProps;
}

export default function BasicModal({
	title,
	subtitle,
	children,
	open,
	handleClose,
	disableOutsideClick = false,
	titleAlign = "center",
	boxStyle,
	boxProps,
}: BasicModalProps) {
	return (
		<Modal
			open={open}
			onClose={(event, reason) => {
				if (disableOutsideClick && reason === "backdropClick") return;
				handleClose();
			}}
			aria-labelledby="basic-modal-title"
			aria-describedby="basic-modal-description"
		>
			<Box style={boxStyle ? { ...S.style, ...boxStyle } : S.style} {...boxProps}>
				{title && <S.TitleContainer $align={titleAlign}>{title}</S.TitleContainer>}
				{subtitle && <S.SubtitleContainer id="basic-modal-description">{subtitle}</S.SubtitleContainer>}
				<div>{children}</div>
			</Box>
		</Modal>
	);
}
